/**
 * What Google must grant before Wundo can receive a Meet call's audio itself,
 * without a bot. Asked for at runtime, when a user of an organisation with the
 * `google_meet_recorder` feature links their calendar; never listed on the
 * consent screen, so the calendar verification is not touched.
 */
export const GOOGLE_MEET_RECORDER_SCOPES = [
  'https://www.googleapis.com/auth/meetings.conference.media.audio.readonly',
  'https://www.googleapis.com/auth/meetings.space.readonly',
] as const;
